// src/component/navbar/ThemeSelector.js
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FaAdjust, FaSun, FaMoon } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';

const THEME_OPTIONS = [
    { value: 'auto',  icon: <FaAdjust/>, label: 'Auto'  },
    { value: 'light', icon: <FaSun/>,    label: 'Light' },
    { value: 'dark',  icon: <FaMoon/>,   label: 'Dark'  },
];

function ThemeSelector() {
    const { theme, setTheme } = useTheme();
    const current = THEME_OPTIONS.find(o => o.value === theme) || THEME_OPTIONS[0];

    return (
        <NavDropdown className="theme-selector" title={<span aria-label={current.label} title={current.label}>{current.icon}</span>} align="end">
            {THEME_OPTIONS.map(option => (
                <NavDropdown.Item
                    key={option.value}
                    onClick={() => setTheme(option.value)}
                    active={theme === option.value}
                    aria-label={option.label}
                    title={option.label}
                >
                    {option.icon}
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
}

export default ThemeSelector;
